/**
 * RESPONSIBILITY: draw an event's labelled facts.
 *
 * A description list and not a table: these are pairs, not a grid, and a table would
 * promise columns that line up between rows that have nothing to do with each other.
 */
import { THEME } from '@app/sections';
import { idOf } from '@framework/core';
import { Band } from './Band';
import type { BandProps } from './kind';

export function Facts({ s }: BandProps) {
  const facts = (s.facts ?? []).filter((f) => f.label || f.value);
  if (!facts.length) return null;

  return (
    <Band theme={THEME.Facts} heading={s.heading}>
      <dl className="ev-facts">
        {facts.map((f) => (
          <div key={idOf(f)}>
            <dt>{f.label}</dt>
            <dd>{f.value}</dd>
          </div>
        ))}
      </dl>
    </Band>
  );
}
